<template>
  <b-modal
    :id="modalId"
    modal-class="guide-modal"
    hide-footer
    hide-header
    centered
    @hide="updatecrew"
  >
    <!-- scrollable -->
    <!--Crew  -->
    <template v-if="active == 'crew'">
      <div class="header__crew">
        <h2>Crew</h2>
        <div class="ico__header">
          <span
            class="ico ico__back"
            v-b-tooltip.hover
            title="Go back"
            @click="hideModal"
          >
            <img :src="arrowbackSVG" />
          </span>
          <span></span>
          <span
            class="ico ico__add"
            @click="active = 'add'"
            v-b-tooltip.hover
            title="New Crew"
          >
            <img :src="pluseditSVG" />
          </span>
          <span
            class="ico ico__search"
            v-b-tooltip.hover
            title="Search"
            @click="active = 'search'"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
                fill="black"
                fill-opacity="0.5"
              />
              <path
                d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
                fill="black"
                fill-opacity="0.5"
              />
            </svg>
          </span>
        </div>
      </div>
      <div class="body__crew">
        <div class="list-wraper">
          <div
            class="list"
            v-for="(cr, i) in crewFiltered"
            :key="i"
            @click="handleCrewToggle(cr, i)"
            :class="{ active: activeCrew.indexOf(cr) >= 0 }"
          >
            <template v-if="cr.user">
              <div class="profile_img">
                <img
                  v-if="cr.user.imgURL"
                  class="user-img"
                  :src="cr.user.imgURL"
                  :alt="cr.nickname"
                />
                <b-avatar
                  v-else
                  variant="secondary"
                  :text="getInitials(cr.nickname)"
                ></b-avatar>
              </div>
              <div class="profile-info">
                <h4>
                  {{ cr.nickname }}
                  <span v-if="cr.user.firstname" class="name"
                    >({{ cr.user.firstname + " " + cr.user.lastname }})</span
                  >
                </h4>
                <h5 v-if="cr.role">{{ cr.role }} ∙ {{ cr.user.email }}</h5>
                <h5 v-else>{{ cr.email }}</h5>
              </div>
              <span class="ico" v-b-tooltip.hover title="Add to crew">
                <svg
                  v-if="activeCrew.indexOf(cr) >= 0"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                  <path
                    d="M4 13.875L8.09091 18L19 7"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>

                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </template>
          </div>
        </div>
      </div>
    </template>

    <!-- /crew -->
    <!-- Add Crew  -->
    <template v-if="active == 'add'">
      <div class="header__crew">
        <h2>Add Crew</h2>
        <div class="ico__header">
          <span
            class="ico ico__back"
            @click="active = 'crew'"
            v-b-tooltip.hover
            title="Go back"
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
              <path
                d="M28 18H8M8 18L16 10M8 18L16 26"
                stroke="#606770"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span></span>
          <span> </span>
          <span> </span>
        </div>
      </div>
      <div class="body__crew">
        <div class="add-wraper">
          <div>
            <label for="full_name">Full Name</label>
            <span class="d-flex">
              <b-avatar
                variant="secondary"
                :text="getInitials(newCrew.nickname)"
              ></b-avatar>
              <input
                type="text"
                class="form-control"
                placeholder="Enter full name"
                v-model="newCrew.nickname"
                @input="
                  suggestNames = true;
                  lockEmail = false;
                "
                @keydown.enter="suggestNames = false"
                :disabled="userExists"
              />
            </span>

            <div v-if="suggestNames" class="overlay-suggestions">
              <div
                class="list"
                v-for="(crew, index) in matchedCrew"
                :key="index"
                @click="selectName(crew)"
              >
                {{ crew.nickname }}
                <span v-if="crew.name" class="name">({{ crew.name }})</span>
              </div>
            </div>
            <label for="email">Email for Lookup</label>
            <input
              name="email"
              type="email"
              class="form-control"
              placeholder="Enter email"
              v-model="newCrew.email"
              :disabled="lockEmail || userExists"
            />
            <label for="role">Role (e.g. Trainer, Doctor)</label>
            <input
              name="role"
              type="text"
              class="form-control"
              placeholder="Enter role"
              v-model="newCrew.role"
              @input="suggestRoles = true"
              @keydown.enter="suggestRoles = false"
              :disabled="userExists"
            />
            <div
              v-if="suggestRoles"
              class="overlay-suggestions overlay-roles-suggestions"
            >
              <div
                class="list"
                v-for="(role, index) in matchedRoles"
                :key="index"
                @click="selectRole(role)"
              >
                {{ role }}
              </div>
            </div>
            <div v-if="userExists" class="confirm-user">
              Is this the user:
              <div class="user-info-container">
                <div class="user-img">
                  <img
                    v-if="dbUser.imgURL"
                    :src="dbUser.imgURL"
                    alt="crew-image"
                  />
                  <b-avatar
                    v-else
                    variant="primary"
                    :text="getInitials(newCrew.nickname)"
                  ></b-avatar>
                </div>
                <div class="user-name">
                  <span v-if="dbUser.firstname" class="db-name">
                    {{
                      `${dbUser.firstname +
                        (dbUser.lastname ? " " + dbUser.lastname : "")}`
                    }}
                  </span>
                  <span v-else class="db-name">
                    {{ dbUser.nickname }}
                  </span>
                  <br />
                  as
                  {{ newCrew.nickname }}
                </div>
                <div class="buttons">
                  <b-button class="yes" @click="addNewCrew()">
                    Yes
                  </b-button>
                  <b-button class="no" @click="reset()">
                    Cancel
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <span></span>
          <button
            v-if="!dbUser.userId"
            class="btn-add-crew"
            @click="addCrewMember"
          >
            Add New Crew
          </button>
        </div>
      </div>
    </template>
    <!-- /add-crew -->
    <!--Crew  -->
    <template v-if="active == 'search'">
      <div class="header__crew header__search">
        <input
          type="search"
          v-model="searchStr"
          class="search"
          placeholder="Search"
          @keypress="updateSearch"
          ref="searchfield"
        />
        <div class="ico" @click="hideSearch">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="14.2222"
                  height="14.2222"
                  fill="white"
                  transform="translate(8.88867 8.88867)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div class="body__crew">
        <div class="list-wraper">
          <div
            class="list"
            v-for="(cr, i) in crewFiltered"
            :key="i"
            @click="handleCrewToggle(cr, i)"
            :class="{ active: activeCrew.indexOf(cr) >= 0 }"
          >
            <template v-if="cr.user">
              <div class="profile_img">
                <img
                  v-if="cr.user.imgURL"
                  class="user-img"
                  :src="cr.user.imgURL"
                  :alt="cr.nickname"
                />
                <b-avatar
                  v-else
                  variant="primary"
                  :text="getInitials(cr.nickname)"
                ></b-avatar>
              </div>
              <div class="profile-info">
                <h4
                  v-html="$options.filters.highlight(cr.nickname, searchStr)"
                ></h4>
                <h5 v-if="cr.role">{{ cr.role }} ∙ {{ cr.user.email }}</h5>
                <h5 v-else>{{ cr.user.email }}</h5>
              </div>
              <span
                class="ico"
                v-if="!(activeCrew.indexOf(cr) >= 0)"
                v-b-tooltip.hover
                title="Add to crew"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
              <span class="ico" v-else>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                  <path
                    d="M4 13.875L8.09091 18L19 7"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </template>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      arrowbackSVG: require("@/assets/svg/arrowback.svg"),
      pluseditSVG: require("@/assets/svg/plusedit.svg"),
      searchStr: "",
      active: "crew",
      lockEmail: false,
      userExists: false,
      dbUser: {
        userId: null,
        imgURL: null,
        firstname: "",
        lastname: ""
      },
      crew: [],
      activeCrew: [],
      myCrew: [],
      newCrew: {
        nickname: "",
        email: "",
        role: ""
      },
      roles: [
        //@TODO - These are suppose to be in MixIns
        "Author",
        "Editor",
        "Illustrator",
        "Contributor"
      ],
      suggestNames: false,
      suggestRoles: false
    };
  },
  props: {
    modalId: {
      type: String,
      default: null
    },
    oldCrew: {
      type: Array,
      default: null
    },
    addedCrew: {
      type: Array,
      default: null
    }
  },
  mounted() {
    this.mountedFunc();
  },
  created() {
    this.unwatchCrewListProp = this.$watch("crewList", newVal => {
      if (newVal) {
        this.mountedFunc();
        this.unwatchCrewListProp();
      }
    });
    this.unwatchOldCrewProp = this.$watch("oldCrew", newVal => {
      if (newVal) {
        this.setOldCrew();
        this.unwatchOldCrewProp();
      }
    });
  },
  watch: {
    active(newv, oldv) {
      if (newv == "search") {
        // this.$refs.search.focus();
        setTimeout(() => {
          document.querySelector(".search").focus();
        }, 100);
      }
    }
  },
  computed: {
    ...mapGetters({
      crewList: "user/listNames",
      savedRoles: "user/listRoles"
    }),
    allRoles() {
      let roles = [];
      this.savedRoles.forEach(role => {
        roles.push(role.text);
      });
      let combinedRoles = [...this.roles, ...roles];
      let uniqeRoles = [...new Set(combinedRoles)];
      return uniqeRoles;
    },
    matchedCrew() {
      let crewList = [];
      if (this.newCrew.nickname == "") {
        return crewList;
      } else {
        this.crew.forEach(crew => {
          if (
            crew.nickname &&
            crew.nickname
              .toLowerCase()
              .includes(this.newCrew.nickname.toLowerCase())
          ) {
            crewList.push(crew);
          }
        });
        return crewList;
      }
    },
    matchedRoles() {
      let roles = [];
      if (this.newCrew.role == "") {
        return roles;
      } else {
        this.allRoles.forEach(role => {
          if (role.toLowerCase().includes(this.newCrew.role.toLowerCase())) {
            roles.push(role);
          }
        });
        return roles;
      }
    },
    crewSearched() {
      if (this.searchStr.trim() == "") return this.crew;

      return this.crew.filter(cr => {
        return (
          cr.name &&
          cr.name.toLowerCase().includes(this.searchStr.toLowerCase().trim())
        );
      });
    },
    crewFiltered() {
      //@TODOCrew Searched and Filtered can be combined along with the dom
      return this.crew.filter(cr => {
        if (this.searchStr.trim() == "") {
          return !cr.replaced;
        } else if (
          cr.user &&
          cr.user.firstame &&
          cr.user.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        ) {
          return !cr.replaced;
        } else if (
          cr.user &&
          cr.user.lastname &&
          cr.user.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        ) {
          return !cr.replaced;
        } else if (
          cr.nickname &&
          cr.nickname &&
          cr.nickname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        ) {
          return !cr.replaced;
        }
        return false;
      });
    }
  },
  filters: {
    highlight(stringToSearch, searchTerm) {
      if (searchTerm === "") return stringToSearch;
      var iQuery = new RegExp(searchTerm, "ig");
      return stringToSearch
        .toString()
        .replace(iQuery, function(matchedText, a, b) {
          return "<span style='font-weight: 800'>" + matchedText + "</span>";
        });
    }
  },
  methods: {
    mountedFunc() {
      //console.log("inside");
      this.crew = [];
      this.myCrew = [];
      this.activeCrew = [];
      if (this.oldCrew.length == 0 && this.addedCrew.length == 0) {
        console.log(this.crewList);
        this.crewList.forEach(crew => {
          let crewmember = {
            uid: crew.uid,
            nickname: crew.info.nickname,
            role: crew.info.role
          };

          if (crew.user) {
            crewmember.user = {
              email: crew.user.email,
              firstname: crew.user.firstname,
              lastname: crew.user.lastname,
              imgURL: crew.user.imgURL,
              userId: crew.user.userId
            };
          }

          this.crew.unshift(crewmember);
        });
        // this.focuses.forEach(focus => {
        //   focus.crew.forEach(crewmember => {
        //     console.log(crewmember);
        //     this.crew.unshift(crewmember);
        //   });
        // });
      } else if (this.addedCrew.length !== 0) {
        this.crew = this.addedCrew;
      }
      //console.log("old crewwww", this.oldCrew);
      if (this.oldCrew) {
        this.oldCrew.forEach(crewmember => {
          this.myCrew.push(crewmember);
          this.activeCrew.push(crewmember);
        });
      }
      //console.log("crewwww", this.crew);
      //console.log("active crewwww", this.activeCrew);
    },
    setOldCrew() {
      this.oldCrew.forEach(crewmember => {
        this.myCrew.push(crewmember);
        this.activeCrew.push(crewmember);
      });
    },
    hideSearch() {
      this.active = "crew";
      this.searchStr = "";
    },
    hideModal() {
      this.$bvModal.hide(this.modalId);
    },
    updatecrew() {
      this.$emit("updateCrew", { active: this.myCrew, all: this.crew });
    },
    getInitials(name) {
      let initials = "";
      let fname = name.split(" ")[0];
      let lname = name
        .split(" ")
        .slice(1)
        .join(" ");
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    handleCrewToggle(crew, index) {
      let current_index = this.activeCrew.indexOf(crew);
      if (current_index >= 0) {
        this.activeCrew.splice(current_index, 1);
        this.myCrew.splice(current_index, 1);
      } else {
        this.myCrew.push(crew);
        this.activeCrew.push(crew);
      }
    },
    updateSearch() {
      return this.crew.forEach(cr => {
        return cr.name.replace(
          "/sa/g",
          '<span class="highlight">' + this.searchStr + "</span>"
        );
      });
    },
    addCrewMember() {
      this.$store
        .dispatch("user/getUserFromDb", this.newCrew.email)
        .then(res => {
          if (res.length > 0) {
            let user = res[0];
            this.dbUser.firstname = user.firstname;
            this.dbUser.lastname = user.lastname;
            this.dbUser.imgURL = user.imgURL;
            this.dbUser.userId = user.userId;
            this.userExists = true;
          } else {
            this.crewList.forEach(cr => {
              if (
                this.dbUser.user &&
                cr.user &&
                cr.user.email === this.newCrew.email
              ) {
                this.dbUser.firstname = cr.user.firstname;
                this.dbUser.lastname = cr.user.lastname;
                this.dbUser.userId = cr.user.userId;
                this.dbUser.nickname = cr.info.nickname;
                this.userExists = true;
              }
            });
          }

          if (!this.userExists) {
            this.addNewCrew();
          }
        });
    },
    addNewCrew() {
      this.crew = this.crew.map(cr =>
        cr.user && cr.user.email === this.newCrew.email
          ? { ...cr, replaced: new Date() }
          : cr
      );

      let uid = this.checkIsNameOnDb();
      let crewmember = {
        _created_at: new Date(),
        uid: uid === 0 || uid > -1 ? uid : undefined,
        nickname: this.newCrew.nickname,
        role: this.newCrew.role,
        user: {
          email: this.newCrew.email,
          firstname: this.dbUser.firstname ? this.dbUser.firstname : null,
          lastname: this.dbUser.lastname ? this.dbUser.lastname : null,
          imgURL: this.dbUser.imgURL ? this.dbUser.imgURL : null,
          userId: this.dbUser.userId ? this.dbUser.userId : null
        }
      };
      console.log(crewmember);
      this.crew.unshift(crewmember);
      this.myCrew.push(crewmember);
      this.activeCrew.push(crewmember);
      this.reset();
    },
    checkIsNameOnDb() {
      let existingEmails = this.crewList.map(el => {
        if (el.user) {
          el.user.email;
        }
      });

      if (existingEmails.includes(this.newCrew.email)) {
        return this.crewList[existingEmails.indexOf(this.newCrew.email)].uid;
      } else {
        return false;
      }
    },
    getPP(uid) {
      if (
        this.$store.getters["user/listNames"].filter(el => el.uid === uid)[0] &&
        this.$store.getters["user/listNames"].filter(el => el.uid === uid)[0]
          .connection
      ) {
        return this.$store.getters["user/listNames"].filter(
          el => el.uid === uid
        )[0].connection.imgURL;
      } else {
        return null;
      }
    },
    selectName(crew) {
      this.newCrew.nickname = crew.nickname;
      this.newCrew.email = crew.user.email;
      this.newCrew.role = crew.role;
      this.suggestNames = false;
      this.lockEmail = true;
    },
    selectRole(role) {
      this.newCrew.role = role;
      this.suggestRoles = false;
    },
    reset() {
      this.newCrew = {
        nickname: "",
        email: "",
        role: ""
      };
      this.dbUser = {
        userId: null,
        imgURL: null,
        firstname: "",
        lastname: ""
      };
      this.active = "crew";
      this.userExists = false;
    },
    closeMe() {
      this.$emit("closeMe", { active: this.myCrew, all: this.crew });
    }
  }
};
</script>

<style lang="scss" scoped>
#block-crew {
  .ico {
    cursor: pointer;
  }
  .header__crew {
    position: relative;
    padding-bottom: 16px;
    h2 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;
      color: #5b606c;
      margin: 0;
    }
    .ico__header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 35px 1fr 40px 60px;
      align-items: center;
      justify-items: flex-end;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom: 1px solid #ddd;
    }
  }
  .body__crew {
    .list-wraper {
      display: flex;
      //   justify-content: center;
      align-items: center;
      flex-direction: column;
      max-height: 600px;
      min-height: 300px;
      overflow-y: scroll;
      padding: 0 12px;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
      .list {
        height: 76px;
        cursor: pointer;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        display: grid;
        grid-template-columns: 44px 1fr 24px;
        grid-column-gap: 18px;
        align-items: center;
        margin: 4px 0;

        &.active {
          background: rgba(85, 126, 251, 0.1);
        }
        h5,
        h4 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin-bottom: 2px;
          .highlight {
            font-weight: 800;
          }
        }
        h5 {
          font-size: 12px;
          line-height: 16px;
          margin: 0;
        }
        .name {
          font-size: 13px;
          font-weight: bold;
        }
        .ico {
          cursor: pointer;
        }
      }
    }
    .add-wraper {
      display: grid;
      grid-template-rows: 1fr 1fr 100px;
      label {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #474d52;
        margin-top: 25px;
      }
      input {
        border: none;
        &:focus {
          box-shadow: none;
        }
      }
      .confirm-user {
        display: block;
        margin-top: 25px;
        margin-left: 25px;
        .user-info-container {
          margin-top: 10px;
          padding: 8px;
          width: 400px;
          height: 66px;
          background: #f3f6f9;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .user-name {
            margin-left: 5px;
            width: 140px;
          }
          .user-img {
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
            .b-avatar {
              color: #8d99a0 !important;
              background-color: rgba(85, 126, 251, 0.1) !important;
            }
          }
          .buttons button {
            width: 80px;
            height: 44px;
            border-radius: 12px;
            margin-left: 5px;
            border: none;
          }
          .yes {
            background: var(--theme-color);
          }
          .no {
            color: var(--theme-color);
            background: rgba(85, 126, 251, 0.1);
          }
        }
        .db-name {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .overlay-suggestions {
        border-radius: 5px;
        background: #f3f6f9;
        position: absolute;
        .list {
          cursor: pointer;
          padding: 12px;
          width: 470px;
          border-radius: 5px;
          .name {
            font-size: 13px;
            font-weight: bold;
          }
        }
        .list:hover {
          background-color: var(--theme-color);
        }
      }
      .overlay-roles-suggestions {
        top: 360px;
      }
    }
  }
  .header__search {
    display: flex;
    align-items: center;
    input {
      border: none;
      padding: 5px 10px;
      width: 100%;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      //   text-align: center;
      color: #5b606c;
    }
  }
}
.user-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
